import { CSSProperties, FC, HTMLAttributes } from "react";
import { NextPage } from "next";
import NextImage from "next/image";

import background from "./background.jpg";
import logo from "./logoMega.svg";
import logoTopo from "./logoMegaWhite.svg";
import { Form } from "./form";

const LoginPage: NextPage = () => {
  return (
    <Root className="flex-fill">
      <div className="d-flex flex-column flex-lg-row flex-column-fluid" style={{ height: "inherit" }}>
        <Anside className="d-flex flex-column flex-lg-row-auto w-xl-600px positon-xl-relative">
          <div className="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
            <LogoWrapperTopo>
              <LogoTopo />
            </LogoWrapperTopo>
            <div className="d-flex flex-row-fluid flex-column text-left p-10 d-none d-lg-block" style={{ marginTop: "30%" }}>
              <h1 className="fw-bolder fs-2qx" style={{ color: "#FFF" }}>MEGA</h1>
              <p className="fs-2" style={{ color: "#FFF", fontWeight: 300 }}>
                Investindo na Energia do Amanhã!
              </p>
            </div>
          </div>
        </Anside>
        <Wrapper className="d-flex flex-column flex-lg-row-fluid py-10">
          <div className="d-flex flex-center flex-column flex-column-fluid">
            <div className="w-lg-500px p-10 p-lg-15 mx-auto">
              <LogoWrapper>
                <Logo />
              </LogoWrapper>
              <Form />
            </div>
          </div>
        </Wrapper>
      </div>
    </Root>
  );
};

export default LoginPage;

const Root: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const style: CSSProperties = {
    height: "inherit",
  };

  return <div style={style} {...props} />;
};

const Anside: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const style: CSSProperties = {
    backgroundColor: "#F2C98A",
    backgroundSize: "cover",
    backgroundImage: `url("${background.src}")`,
  };

  return <div style={style} {...props} />;
};

export const Wrapper: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const style: CSSProperties = {};

  return <div style={style} {...props} />;
};

const LogoWrapper: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const style: CSSProperties = {
    padding: "0 32px",
    textAlign: "center",
    margin: "0 auto 4rem auto",
  };

  return <div style={style} {...props} />;
};

const Logo = () => {
  return <NextImage src={logo} width={328} height={65} alt="logo" />;
};

const LogoWrapperTopo: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const style: CSSProperties = {
    padding: "30px 32px",
    textAlign: "left",
    margin: "20px 0px 4rem",
  };

  return <div style={style} {...props} />;
};

const LogoTopo = () => {
  return <NextImage src={logoTopo} width={200} height={40} alt="logo" />;
};
